<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Treść',
              modelPath: [this, 'form', 'text'],
              multilingual: true
            }),
            new fields.Switch({
              label: 'Pełna szerokość tekstu',
              modelPath: [this, 'form', 'text_has_full_width']
            }),
            new fields.Switch({
              label: 'Mniejszy padding',
              modelPath: [this, 'form', 'is_smaller_padding']
            })
          ]
        }
      ]
    }
  }
}
</script>
